<template>
  <div class="content-dashboard">
    <!-- Header -->
    <div class="bg-topography"></div>
    <div class="header-dashboard">
      <div class="logo">
        <img src="@/assets/logo2.png" alt="logo-text" />
      </div>
      <div class="welcome">
        <h1>Hola 😊💜</h1>
        <span>¡Bienvenid@ de nuevo a Siete!</span>
      </div>
    </div>
    <!-- Diagnostics -->
    <section v-if="!loading" class="section">
      <!-- Content -->
      <div class="grid-cols-3">
        <!-- Header Content -->
        <div class="headerContent full-width-grid">
          <div class="card-hc">
            <span class="title-hc">Empresa</span>
            <div class="content-hc">
              <div class="icon-b">
                <i class="material-icons is-size-5 has-text-white">domain</i>
              </div>
              <span class="ellipsis">{{ empresa.nombre }}</span>
            </div>
          </div>
          <div
            v-if="mainReport"
            class="card-hc cursor-pointer"
            v-on:click="toMainReport()"
          >
            <span class="title-hc">Reporte destacado</span>
            <div class="content-hc">
              <div class="icon-b">
                <i class="material-icons is-size-5 has-text-white">web</i>
              </div>
              <span class="ellipsis">{{ mainReport.title }}</span>
            </div>
          </div>
        </div>
        <!-- Diagnostics -->
        <div
          class="card-d"
          v-for="(diag, key) in diagnostics"
          :class="{ active: diag.status, inactive: !diag.status }"
          :key="key"
        >
          <div v-on:click="selectDiagnostic(diag)">
            <div class="is-flex is-justify-start gap-10">
              <div class="icon-h" v-html="diag.icon"></div>
              <div class="card-h">
                <h1 class="title-h">{{ diag.value }}</h1>
                <span class="subtitle-h">{{ diag.subtitle }}</span>
              </div>
            </div>
            <div
              class="card-c"
              v-if="diag.status && Object.keys(diag.process).length"
            >
              <span class="nameDiag ellipsis">{{ diag.process.name }}</span>
              <span class="createdDiag ellipsis"
                >Creado {{ dateProcess(diag.process.created) }}</span
              >
            </div>
          </div>
          <div v-if="!diag.status" class="unavailable">
            <div class="is-flex is-justify-start align-items-end gap-10">
              <div class="icon-un">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12 2C9.243 2 7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7c0-2.757-2.243-5-5-5M9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9zm4 10.723V20h-2v-2.277a1.993 1.993 0 0 1 .567-3.677A2 2 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723"
                  />
                </svg>
              </div>
              <div class="content-un">
                Aun no cuentas con este diagnóstico, haz clic
                <a href="https://sietegho.com/servicios/" target="_blank"
                  >aquí</a
                >
                para conocer más.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Loading -->
    <!-- <section v-if="loading" class="section is-flex is-justify-center">
      <div class="loading-d">
        <Loading7 />
      </div>
    </section> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      loading: true,
      diagnostics: [
        {
          // CL7
          key: "clima",
          icon: `<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g fill="none">
                  <path
                    d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"
                  />
                  <path
                    fill="currentColor"
                    d="M13 3a1 1 0 1 0-2 0v3.586L8.707 4.293a1 1 0 0 0-1.414 1.414L11 9.414V11H9.414L5.707 7.293a1 1 0 0 0-1.414 1.414L6.586 11H3a1 1 0 1 0 0 2h3.586l-2.293 2.293a1 1 0 1 0 1.414 1.414L9.414 13H11v1.586l-3.707 3.707a1 1 0 1 0 1.414 1.414L11 17.414V21a1 1 0 1 0 2 0v-3.586l2.293 2.293a1 1 0 0 0 1.414-1.414L13 14.586V13h1.586l3.707 3.707a1 1 0 0 0 1.414-1.414L17.414 13H21a1 1 0 1 0 0-2h-3.586l2.293-2.293a1 1 0 0 0-1.414-1.414L14.586 11H13V9.414l3.707-3.707a1 1 0 0 0-1.414-1.414L13 6.586z"
                  />
                </g>
              </svg>`,
          value: 0,
          subtitle: "Clima Organizacional",
          status: false,
          process: {},
          role: ["free"],
        },
        {
          // Leader
          key: "leader",
          icon: `<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M16.23 18L12 15.45L7.77 18l1.12-4.81l-3.73-3.23l4.92-.42L12 5l1.92 4.53l4.92.42l-3.73 3.23zM12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2"
                />
              </svg>`,
          value: 0,
          subtitle: "Líderes PHD",
          status: false,
          process: {},
          role: ["lider", "ghumana"],
        },
        {
          // Frp v2
          key: "frpNew",
          icon: `<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M14 8.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 14 8.5m0 4a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M10 17a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-8.5A1.5 1.5 0 0 0 8.5 10a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 10 8.5m4 12a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m0-3.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m7-3.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M18 5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m-8-.5A1.5 1.5 0 0 0 8.5 14a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M10 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0-3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m0 17a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m-7-7a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m11-10a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M14 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m7 3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M6 5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M3 9.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M6 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1"
                />
              </svg>`,
          value: 0,
          subtitle: "Factores de riesgo V2",
          status: false,
          process: {},
          role: ["frp"],
        },
        {
          // Cultura
          key: "cultura",
          icon: `<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M4 14q-.825 0-1.412-.587T2 12t.588-1.412T4 10t1.413.588T6 12t-.587 1.413T4 14m.95 3.6l2.95-2.95q.275-.275.7-.275t.7.275t.275.7t-.275.7L6.35 19q-.275.275-.7.275T4.95 19t-.275-.7t.275-.7m3-8.3L5 6.35q-.275-.275-.275-.7T5 4.95t.7-.275t.7.275L9.35 7.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275M12 22q-.825 0-1.412-.587T10 20t.588-1.412T12 18t1.413.588T14 20t-.587 1.413T12 22m0-16q-.825 0-1.412-.587T10 4t.588-1.412T12 2t1.413.588T14 4t-.587 1.413T12 6m2.65 1.9l3-2.95q.275-.275.688-.288t.712.288q.275.275.275.7t-.275.7l-2.975 2.975q-.3.3-.712.3t-.713-.3q-.275-.3-.288-.712t.288-.713m3 11.1l-2.95-2.95q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l2.95 2.95q.275.275.275.7t-.275.7t-.7.275t-.7-.275M20 14q-.825 0-1.412-.587T18 12t.588-1.412T20 10t1.413.588T22 12t-.587 1.413T20 14"
                />
              </svg>`,
          value: 0,
          subtitle: "Diagnostico Cultura",
          status: false,
          process: {},
          role: ["cliente"],
        },
        {
          // Eco
          key: "climaOld",
          icon: `<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M8 9q-.425 0-.712-.288T7 8t.288-.712T8 7h12q.425 0 .713.288T21 8t-.288.713T20 9zm0 4q-.425 0-.712-.288T7 12t.288-.712T8 11h12q.425 0 .713.288T21 12t-.288.713T20 13zm0 4q-.425 0-.712-.288T7 16t.288-.712T8 15h12q.425 0 .713.288T21 16t-.288.713T20 17zM4 9q-.425 0-.712-.288T3 8t.288-.712T4 7t.713.288T5 8t-.288.713T4 9m0 4q-.425 0-.712-.288T3 12t.288-.712T4 11t.713.288T5 12t-.288.713T4 13m0 4q-.425 0-.712-.288T3 16t.288-.712T4 15t.713.288T5 16t-.288.713T4 17"
                />
              </svg>`,
          value: 0,
          subtitle: "Diagnostico Eco",
          status: false,
          process: {},
          role: ["cliente"],
        },
        {
          // Frp v1
          key: "frp",
          icon: `<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M14 8.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 14 8.5m0 4a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M10 17a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-8.5A1.5 1.5 0 0 0 8.5 10a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 10 8.5m4 12a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m0-3.5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m7-3.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M18 5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m-8-.5A1.5 1.5 0 0 0 8.5 14a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5a1.5 1.5 0 0 0-1.5-1.5M10 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m0-3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5m0 17a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m-7-7a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5m11-10a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M14 7a1 1 0 0 0 1-1a1 1 0 0 0-1-1a1 1 0 0 0-1 1a1 1 0 0 0 1 1m7 3.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5M6 5a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1M3 9.5a.5.5 0 0 0-.5.5a.5.5 0 0 0 .5.5a.5.5 0 0 0 .5-.5a.5.5 0 0 0-.5-.5M6 9a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0 8a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1m0-4a1 1 0 0 0-1 1a1 1 0 0 0 1 1a1 1 0 0 0 1-1a1 1 0 0 0-1-1"
                />
              </svg>`,
          value: 0,
          subtitle: "Factores de riesgo V1",
          status: false,
          process: {},
          role: ["cliente"],
        },
      ],
      mainReport: null,
    };
  },
  computed: {
    ...mapState(["idtoken", "tokenUser", "empresa"]),
  },
  methods: {
    async selectDiagnostic(diag) {
      if (!this.validRoles(diag)) return;

      if (diag.process && diag.process.url) {
        await this.$swal({
          html: `Proceso <strong>${diag.process.name}</strong> seleccionado correctamente.`,
          icon: "success",
          showConfirmButton: false,
          timer: 1700,
          willClose: () => {
            this.$router.push(diag.process.url);
          },
        });
      }
    },
    async getDataDiagnostics() {
      try {
        const result = await apiServices.get("/company/diagnostics");
        if (result.data) {
          this.setDiagnostics(result.data);
          this.loading = false;
        }
      } catch (error) {
        // this.loading = false;
        console.log(error);
      }
    },
    async getMainReport() {
      try {
        const result = await apiServices.get(`/informeprincipal`);
        if (result.data) {
          this.mainReport = result.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toMainReport() {
      this.$router.push("/main-report");
    },
    setDiagnostics(newData) {
      this.diagnostics.map((d, k) => {
        const newValue = newData[d.key];
        const lastProcess = newData[`${d.key}ProcessLast`];

        this.diagnostics[k].value = newValue;
        this.diagnostics[k].status =
          typeof newValue === "string" ? newValue !== "Inactivo" : !!newValue;
        if (lastProcess && Object.keys(lastProcess).length)
          this.diagnostics[k].process = lastProcess;
      });
    },
    validRoles(diag) {
      if (this.tokenUser && this.tokenUser.admin) return true;

      const permDiagnostic = diag.role.filter((r) => {
        if (this.tokenUser[r]) return true;
      });
      return this.tokenUser && !!permDiagnostic.length;
    },
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "numeric", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
  },
  beforeMount() {
    if (this.idtoken) {
      this.getMainReport();
      this.getDataDiagnostics();
    }
  },
  watch: {
    idtoken() {
      this.getMainReport();
      this.getDataDiagnostics();
    },
  },
};
</script>

<style lang="scss" scoped>
.content-dashboard {
  padding: 25px 0 25px 0;
  background-color: #fafafa;
}

.bg-topography {
  position: absolute;
  top: 0;
  right: -20%;
  width: 100%;
  height: 100%;
  opacity: 0.9;
  z-index: 0;
  background-image: url("~@/assets/bg-login.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    right: -85%;
    width: 190%;
  }
}

.header-dashboard {
  display: flex;
  justify-content: space-between;
}

.logo {
  display: flex;
  background: white;
  visibility: visible;
  padding: 15px;
  width: 22%;
  border-radius: 0 16px 0 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    visibility: hidden;
  }
}

.logo img {
  width: 77%;
}

.welcome {
  z-index: 2;
  display: flex;
  background: white;
  padding: 25px;
  min-width: 22%;
  border-radius: 0 0 0 16px;
  margin-right: -16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.welcome > h1 {
  font-weight: 900;
  font-size: 25px;
}

.headerContent {
  gap: 10px;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.headerContent .icon-b {
  padding: 5px;
  display: flex;
  color: white;
  border-radius: 5px;
  align-items: center;
  background-color: #623392;
}

.card-hc {
  gap: 2px;
  width: 100%;
  display: flex;
  padding: 10px;
  overflow: hidden;
  text-align: start;
  border-radius: 5px;
  background: white;
  flex-direction: column;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-hc .title-hc {
  font-size: 14px;
  font-weight: 700;
}

.card-hc .content-hc {
  gap: 10px;
  display: flex;
  align-items: center;
}

.card-hc.cursor-pointer:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.card-d {
  display: flex;
  padding: 20px;
  cursor: pointer;
  overflow: hidden;
  min-height: 170px;
  border-radius: 16px;
  position: relative;
  background: white;
  flex-direction: column;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-d.active:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.card-d.inactive:active {
  animation: shake 0.3s ease-in-out;
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(5px);
  }
  60% {
    transform: translateX(-5px);
  }
  80% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
}

.card-d .card-h {
  text-align: left;
  line-height: 1.3;
  margin-right: 5px;
}

.card-h .title-h {
  font-size: 36px;
  font-weight: 600;
}

.card-d .icon-h {
  color: #623392;
}

.icon-h /deep/ svg {
  width: 75px !important;
  height: 75px !important;
}

.card-d .card-c {
  display: flex;
  padding: 10px;
  text-align: center;
  border-radius: 16px;
  flex-direction: column;
  background-color: #f3f3f3;
}

.card-c .nameDiag {
  font-size: 14px;
  font-weight: 600;
  width: 100%;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-c .createdDiag {
  font-size: 14px;
}

.unavailable {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  height: 100%;
  display: flex;
  color: white;
  font-size: 18px;
  align-items: end;
  font-weight: bold;
  padding: 20px 25px;
  border-radius: 16px;
  backdrop-filter: blur(2px);
  justify-content: space-between;
  background: rgba(99, 51, 146, 0.5);
}

.unavailable .icon-un {
  color: white;
  display: flex;
  align-items: center;
}

.unavailable .content-un {
  font-size: 12px;
  text-align: center;
}

.content-un a {
  font-weight: 600;
  color: #623392;
}

.icon-un svg {
  width: 65px;
  height: 65px;
}

.loading-d {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  transition: opacity 0.3s ease-in-out;
}

.grid-cols-3 {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  padding: 10px 10px 10px;
}

@media (min-width: 1024px) {
  .grid-cols-3 {
    grid-template-columns: repeat(3, 1fr);
    padding: 80px 150px 0 150px;
  }

  .headerContent {
    display: flex;
    flex-wrap: nowrap !important;
  }
}

.align-items-end {
  align-items: flex-end;
}

.full-width-grid {
  grid-column: 1 / -1;
}

.cursor-pointer {
  cursor: pointer;
}

.gap-10 {
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/DashBoard/Dashboard.vue